<template>
  <div>
    <Row :gutter="24" class="ivu-mt">
      <Col :xl="10" :lg="8" :md="8" :sm="12" :xs="24" class="ivu-mb">
        <notice />
      </Col>
      <Col :xl="6" :lg="8" :md="8" :sm="12" :xs="24" class="ivu-mb">
        <shortcut />
      </Col>
    </Row>
  </div>
</template>
<script>
  import mixinPage from '../../mixins/page';
  import shortcut from '../../components/home/shortcut';
  import notice from '../../components/home/notice';

  export default {
    name: 'home',
    mixins: [mixinPage],
    components: { notice, shortcut },
    data() {
      return {
        grid: {
          xl: 12,
          lg: 12,
          md: 12,
          sm: 12,
          xs: 12
        }
      };
    },
    async mounted() {},
    methods: {}
  };
</script>

<style scoped>
  .stat {
    display: flex;
  }
  .stat .icon {
    width: 50%;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }

  .stat .icon i {
    font-size: 64px;
  }

  .stat .content {
    width: 50%;
  }

  .stat .content .value1 {
    font-size: 12px;
    float: right;
    margin-top: 18px;
  }
  .stat .content .value2 {
    font-size: 12px;
    float: right;
    margin-top: 8px;
  }
</style>
